// https://github.com/swimlane/ngx-datatable/issues/1367#issuecomment-511893170
import { AfterViewChecked, AfterViewInit, Directive, ElementRef, Renderer2 } from "@angular/core";

/**
 * Directive to add an empty row to `ngx-datatable components that do not have any data.
 * This fixes a bug with ngx-datatable in which empty tables do not have a scrollable header.
 */
@Directive({
    selector: "ngx-datatable",
    standalone: false
})
export class EmptyRowDirective implements AfterViewInit, AfterViewChecked {
  private datatableBodyEl!: HTMLElement;
  private datatableEmptyRowEl!: HTMLElement;
  private datatableRowCenterEl!: HTMLElement;
  private prevNumberOfRows!: number;
  constructor(
    private renderer: Renderer2,
    private hostElRef: ElementRef
  ) {}

  public ngAfterViewInit() {
    this.setUpElementReferences();
    if (this.shouldApplyHack) {
      this.hackEmptyCellWidth();
      this.setUpHeaderScrollListener();
    }
  }

  public ngAfterViewChecked() {
    if (this.shouldApplyHack) {
      this.hackEmptyCellWidth();
    }
    this.restartScrollingOnRowChanges();
  }

  private restartScrollingOnRowChanges() {
    if (this.prevNumberOfRows !== this.numberOfRows) {
      this.prevNumberOfRows = this.numberOfRows;
      this.datatableBodyEl.scrollTo(1, 0);
      this.renderer.setStyle(this.datatableRowCenterEl, "transform", "translate3d(0px, 0px, 0px)");
    }
  }

  private setUpHeaderScrollListener() {
    this.renderer.listen(this.datatableBodyEl, "scroll", (event: any) => {
      if (this.shouldApplyHack) {
        this.renderer.setStyle(
          this.datatableRowCenterEl,
          "transform",
          `translate3d(-${event.srcElement.scrollLeft}px, 0px, 0px)`
        );
      }
    });
  }

  private hackEmptyCellWidth() {
    const newWidth = this.datatableRowCenterEl.style.width;
    this.renderer.setStyle(this.datatableEmptyRowEl, "width", newWidth);
  }

  private setUpElementReferences() {
    const hostEl = this.hostElRef.nativeElement;
    this.datatableBodyEl = hostEl.getElementsByClassName("datatable-body")[0];
    this.datatableEmptyRowEl = hostEl.getElementsByClassName("empty-row")[0];
    this.datatableRowCenterEl = hostEl.getElementsByClassName("datatable-row-center")[0];
  }

  private get shouldApplyHack(): boolean {
    const hostEl = this.hostElRef.nativeElement;
    this.datatableEmptyRowEl = hostEl.getElementsByClassName("empty-row")[0];
    return !!this.datatableEmptyRowEl;
  }

  private get numberOfRows(): number {
    const hostEl = this.hostElRef.nativeElement;
    return hostEl.getElementsByClassName("datatable-body-row").length;
  }
}
